"use client";

import dynamic from "next/dynamic";

import { useChatBot } from "./chat-bot-context";

// Client-only leaves pulled out of the eager bundle. `ssr: false` needs a client
// component to live in, hence this wrapper — layout.tsx stays a server component.

// Decorative desktop cursor (drags in gsap); already no-ops below 768px.
const CustomCursor = dynamic(() => import("./custom-cursor"), { ssr: false });

// The chat panel drags in @ai-sdk/react + ai + react-markdown + remark-gfm.
// It's invisible until opened from the command menu, so only mount it once the
// user actually reaches for it, then keep it mounted to preserve the thread.
const ChatBot = dynamic(
  () => import("./chat-bot").then((m) => m.ChatBot),
  { ssr: false },
);

export function ClientExtras() {
  const { hasOpened } = useChatBot();

  return (
    <>
      <CustomCursor />
      {hasOpened && <ChatBot />}
    </>
  );
}
